import { useState } from "react";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import FormHelperText from "@mui/material/FormHelperText";

import GridSectionHeader from "../../widgets/GridSectionHeader";
import DependantRepeater from "./DependantRepeater";
import DependantList, { dependantCount } from "./DependantList";
import PageNavigator, { onNext } from "../../PageNavigator";

import { alphanum } from "../../../utils/fieldValidator.js";
import { MAX_LENGTH_TEXTAREA } from "../../../utils/constants.js";

import {
  ConstructionOutlined,
  KeyboardReturnOutlined,
} from "@mui/icons-material";

let dependantDisclosureError = "";
let noDisclosureDescError = "";

export default function DependantDetails() {
  //FORM VALIDATATION STATUS
  const [isValid, setIsValid] = useState(false);

  const [dependantDisclosure, setDependantDisclosure] = useState("");
  const [noDisclosureDesc, setNoDisclosureDesc] = useState("");

  //COMPONENT ID
  let id = "";

  //CALLED WHEN "NEXT BUTTON" IS PRESSED. WHEN ATTEMPTING TO MOVE TO NEXT PAGE.
  function validateForm(e) {
    e.preventDefault();

    if (dependantDisclosure === "DEPENDANT_YES") {
      //WHEN THERE ARE DEPENDANTS CONSIDER DEPENDANT LIST VALID ONES IT"S NO LONGER EMPTY / ZERO
      if (dependantCount <= 0) {
        alert("Please provide dependant information.");
        return;
      } else setIsValid(true);
    } else if (dependantDisclosure === "DEPENDANT_CONFIDENTIAL") {
      if (noDisclosureDesc.length === 0) {
        noDisclosureDescError = "Please provide a reason";
        setIsValid(false);
        return;
      } else if (noDisclosureDesc.length > MAX_LENGTH_TEXTAREA) {
        noDisclosureDescError = "Exceeded 1000 characters";
        return;
      } else {
        noDisclosureDescError = "";
        setIsValid(true);
      }
    }

    onNext();
  }

  /**
   * 1. VALIDITE FORM USING ERROR MESSAGES
   *     "CALCULATE VALIDITY" IS SIMILAR TO "VALIDATE FORM" IT VALIDATES BY ERROR MESSAGE.
   *       WHEN ALL FIELD'S ERROR MESSAGES ARE EMPTY. (VALID = TRUE)
   *
   * 2. THIS FUNCTION IS ALSO RESPONSIBLE FOR ENABLING / DISABLING THE NEXT BUYTTON, THEREFORE IS TRIGGERED BY EACH UI EVENT
   */
  function calculateValidity() {
    if (
      dependantDisclosureError.length === 0 &&
      noDisclosureDescError.length === 0
    ) {
      setIsValid(true);
    }
  }

  function handleChange(e, object) {
    id = "";

    if (e instanceof PointerEvent) {
      //DROPDOWNS
      id = object.props.id.toLowerCase();
    } else {
      //RADIO BUTTONS & TEXTFIELDS
      let type = "";
      let name = "";

      id = e.target.id;

      if (id === "") {
        type = e.target.type;
        name = e.target.name;
      }

      //DEPENDANT DISCLOSURE
      if (type === "radio" && name === "dependant-disclosure") {
        setDependantDisclosure(e.target.value.toUpperCase());
        dependantDisclosureError = "";
      }

      //TRUSTEE INFORMATION
      if (id === "noDisclosureDesc" && alphanum.test(e.target.value)) {
        if (e.target.value.length === 0)
          noDisclosureDescError = "Please provide a reason";
        else if (e.target.value.length > MAX_LENGTH_TEXTAREA)
          noDisclosureDescError = "Exceeded 1000 characters";
        else noDisclosureDescError = "";

        setNoDisclosureDesc(e.target.value);
      }
    }

    calculateValidity();
  }

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        <Grid container spacing={2}>
          <Grid size={12}>
            {/*==============================
            DEPENDANT -DECLARE AVAILABILITY
           ==============================*/}
            <Typography variant="h6" gutterBottom>
              Do you have dependant you wish to disclose?
            </Typography>

            <RadioGroup
              id="dependant-disclosure"
              name="dependant-disclosure"
              defaultValue=""
              value={dependantDisclosure}
              onChange={handleChange}
            >
              <FormControl>
                <Stack direction="column">
                  <FormControlLabel
                    id="dependantYes"
                    value="DEPENDANT_YES"
                    control={<Radio />}
                    label="Yes, I have dependant(s)"
                  />

                  <FormControlLabel
                    id="dependantNone"
                    value="DEPENDANT_NONE"
                    control={<Radio />}
                    label="No, I do not have any dependants."
                  />

                  <FormControlLabel
                    id="dependantConfidential"
                    value="DEPENDANT_CONFIDENTIAL"
                    control={<Radio />}
                    label="No, I do not wish to disclose my dependants information and for it to be taken into consideration for needs analysis and recommendations."
                  />
                </Stack>
              </FormControl>
            </RadioGroup>

            {/*==============================
            DEPENDANT - DECLARATION DETAILS (NOT INCLUDED)
           ==============================*/}
            {dependantDisclosure === "DEPENDANT_CONFIDENTIAL" ? (
              <>
                <Typography variant="body1" gutterBottom sx={{ pt: 1 }}>
                  Please provide details
                </Typography>
                <TextareaAutosize
                  id="noDisclosureDesc"
                  placeholder="Private & confidential"
                  style={{ width: "100%" }}
                  minRows={5}
                  onChange={handleChange}
                />
                {noDisclosureDescError ? (
                  <FormHelperText error={noDisclosureDescError}>
                    {noDisclosureDescError}
                  </FormHelperText>
                ) : (
                  ""
                )}
              </>
            ) : (
              ""
            )}
          </Grid>

          {/* {dependantDisclosure === "DEPENDANT_YES" ? (
            <>
              <GridSectionHeader sectionName="Add dependants" />
              <Typography variant="body1" gutterBottom>
                A dependant is a person who relies on another as a priomary
                source of income.
              </Typography>
              <DependantRepeater />
            </>
          ) : (
            ""
          )} */}

          {dependantDisclosure === "DEPENDANT_YES" ? (
            <>
              <GridSectionHeader sectionName="Add dependants" />
              <Typography variant="body1" gutterBottom>
                A dependant is a person who relies on another as a priomary
                source of income.
              </Typography>

              <DependantList />
            </>
          ) : (
            ""
          )}

          <PageNavigator validator={validateForm} isValid={isValid} />
        </Grid>
      </Box>
    </>
  );
}
